import { formatNumber, getRemainingTimeTexts, pluralize } from '../../utils/index';
import ProfileInfoFactory from '../../user/profile-info/ProfileInfoFactory';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import { canShowHistory, getPercentageFundedForProject, isActive } from '../project-model';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import RoundedButtonAction from '../../components/button/rounded-button-action/RoundedButtonAction';
import styles from './project-embedded.module.less';

const Link = ({ project, children }) => {
    return (
        <TrackEventLink
            category="Project embedded"
            action={`Click`}
            label={project.id.toString()}
            to={`https://www.spleis.no/project/${project.id}`}
            target={'"_blank"'}
            className={styles.linkBlock}
        >
            {children}
        </TrackEventLink>
    );
};

export const ProjectEmbeddedComponent = ({ project, small = false }) => {
    const remainingTimeTexts = getRemainingTimeTexts(project);

    const percentageFunded = getPercentageFundedForProject({ project });

    const percentage = project.moneygoal ? (
        <div>
            samlet inn <strong>{percentageFunded}</strong>
            &nbsp;% av målet
        </div>
    ) : (
        <div>samlet inn totalt</div>
    );

    const moneygoal = parseInt(project.moneygoal, 10);
    return (
        <div className={small ? styles.smallContainer : styles.container}>
            <Link project={project}>
                <div
                    style={{
                        backgroundImage: project.img_url ? `url(${project.img_url})` : null,
                    }}
                    className={[
                        project.img_url ? styles.fullImage : styles.noImage,
                        small ? styles.smallImage : '',
                    ].join(' ')}
                />
                <div className={styles.textContainer}>
                    <div>
                        <div className={small ? styles.smallTitle : styles.title}>{project.title}</div>
                        <div className={styles.profile}>
                            <ProfileInfoFactory
                                project={project}
                                textContainerClassName={styles.profileTextContainer}
                                imageSize={40}
                                disableEdit
                            />
                        </div>
                    </div>
                    <div className={styles.projectNumbersGrid}>
                        <div className={styles.money}>{formatNumber(project.collected_amount)} kr</div>
                        {canShowHistory(project) && moneygoal ? (
                            <div className={styles.progressbar}>
                                <ProgressBar
                                    percent={percentageFunded}
                                    matchingPercent={project.matchingPercentFunded}
                                    matchingGift={!!project.matchingGift}
                                    matchingColor={project.matchingGift?.color}
                                    mini
                                />
                            </div>
                        ) : null}
                        <div className={styles.percent}>{percentage}</div>
                        <div className={styles.buttonContainer}>
                            <RoundedButtonAction
                                className={styles.goToProjectButton}
                                category="Project embedded"
                                action={`Click`}
                                label={project.id.toString()}
                            >
                                {isActive(project) ? 'Støtt' : 'Se'}
                            </RoundedButtonAction>
                            <div className={styles.giverCountAndTime} suppressHydrationWarning>
                                {project.giver_count} {pluralize(project.giver_count, ' giver', ' givere')},{' '}
                                {remainingTimeTexts.generalText
                                    ? remainingTimeTexts.generalText
                                    : remainingTimeTexts.timeAndText}
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};
